import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import styled from '@emotion/styled';
import { LionTranslate, lionSelectors } from '@rosetta/react-lion';
import { appSelectors } from '../reducer/app-reducer';

const isMobile = /Mobile/.test(navigator.userAgent);

const BrowserSupportContainer = styled.div({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'left',
  paddingLeft: isMobile ? 20 : 100,
  backgroundColor: '#F1F3F6',
  justifyContent: 'center',
  marginTop: 30,
  height: '100%',
  width: '100%'
});

const BrowserMessage = styled.div({
  textAlign: 'left',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'left',
  maxWidth: 900,
  marginLeft: 15,
  marginRight: 15
});

const Title = styled.div({
  textAlign: 'left',
  fontFamily: "'NotoSans', 'NotoSans_Hebrew', 'NotoSans_Arabic', 'NotoSans_Hindi', 'NotoSans_JP', 'NotoSans_KR', 'NotoSans_TC', 'NotoSans_SC'",
  color: '#3E3D3F',
  fontSize: 32,
  lineHeight: '39px',
  marginBottom: 30
});
const Message = styled.div({
  textAlign: 'left',
  fontFamily: "'NotoSans', 'NotoSans_Hebrew', 'NotoSans_Arabic', 'NotoSans_Hindi', 'NotoSans_JP', 'NotoSans_KR', 'NotoSans_TC', 'NotoSans_SC'",
  color: '#3E3D3F',
  fontSize: 22,
  lineHeight: 1.5,
  marginBottom: 30
});

const BrowsersList = styled.ul({
  textAlign: 'left',
  fontFamily: "'NotoSans', 'NotoSans_Hebrew', 'NotoSans_Arabic', 'NotoSans_Hindi', 'NotoSans_JP', 'NotoSans_KR', 'NotoSans_TC', 'NotoSans_SC'",
  color: '#3E3D3F',
  fontSize: 22,
  lineHeight: 1.5,
  marginBottom: 30
});

const Requirements = styled.div({
  fontFamily: "'NotoSans', 'NotoSans_Hebrew', 'NotoSans_Arabic', 'NotoSans_Hindi', 'NotoSans_JP', 'NotoSans_KR', 'NotoSans_TC', 'NotoSans_SC'",
  color: '#3E3D3F',
  fontSize: 22,
  lineHeight: 1.5,
  marginTop: 50,
  marginBottom: 30
});

const Button = styled.button({
  color: '#ffffff',
  fontFamily: "'NotoSans', 'NotoSans_Hebrew', 'NotoSans_Arabic', 'NotoSans_Hindi', 'NotoSans_JP', 'NotoSans_KR', 'NotoSans_TC', 'NotoSans_SC'",
  fontSize: 18,
  background: '#4195D3',
  borderRadius: 6,
  padding: '15px 50px',
  width: 363,
  marginBottom: 30
});

export class UnsupportedBrowser extends PureComponent {
  render = () => {
    if (!this.props.lionLoaded && !!this.props.lionLanguage) {
      return null;
    }
    return (
      <BrowserSupportContainer>
        <BrowserMessage>
          <Title>
            <LionTranslate lionkey="browser_support_title" />
          </Title>
          <Message>
            <LionTranslate lionkey="browser_support_warn" />
          </Message>

          <BrowsersList>
            <li>Chrome</li>
            <li>Firefox</li>
            <li>Microsoft Edge</li>
            <li>Safari</li>
          </BrowsersList>

          <Requirements>
            <LionTranslate lionkey="browser_support_requirements" />
          </Requirements>

          <Button onClick={() => this.props.history.push(this.props.unsupportedOriginUrl)}>
            <LionTranslate lionkey="browser_support_continue" />
          </Button>
        </BrowserMessage>
      </BrowserSupportContainer>
    );
  };
}

const mapStateToProps = (state, ownprops) => ({
  lionLoaded: lionSelectors.getLionAppResourcesLoaded(state),
  lionLanguage: lionSelectors.getLionLanguage(state),
  unsupportedOriginUrl: appSelectors.getUnsupportedOriginUrl(state)
});

export const UnsupportedBrowserContainer = connect(
  mapStateToProps,
  {}
)(UnsupportedBrowser);



// WEBPACK FOOTER //
// ./src/modules/app/components/UnsupportedBrowser.jsx